import { getFormfieldIcon } from "../utils/utils"

class Formfields {
  constructor() {
    this.addInputIcons()
    this.submitOnChange()
    this.productDropdownOnChange()
  }

  submitOnChange() {
    document.querySelectorAll("[data-submit-on-change]").forEach(el => {
      const eventType = el.type === "date" && window.matchMedia("(pointer: coarse)").matches ? "blur" : "change"
      el.addEventListener(eventType, () => {
        let submitButton = document.querySelector(el.getAttribute("data-submit-on-change"))
        if (submitButton) {
          submitButton.click()
        }
      })
    })
  }

  addInputIcons() {
    document.querySelectorAll("input[class*=formfield-icon-]").forEach(el => {
      const icon = getFormfieldIcon(el)
      if (icon) {
        el.classList.add("with-icon")
        el.parentNode.appendChild(icon)
      }
    })
  }

  productDropdownOnChange() {
    document.querySelectorAll(".product-dropdown select.dropdown").forEach(el => {
      this.setProductSubtotal(el)
      el.addEventListener("change", () => {
        this.setProductSubtotal(el)
      })
    })
  }

  setProductSubtotal(el) {
    this.setProductTotal()
    const readOnlyElement = el.closest(".product-dropdown").querySelector(".readonly .readonly")
    if (readOnlyElement) {
      readOnlyElement.innerHTML = `$${this.parseProductAmount(el.value).toFixed(2)}`
    }
  }

  getProductTotal() {
    let total = 0

    document.querySelectorAll(".product-dropdown select.dropdown").forEach(el => {
      total += this.parseProductAmount(el.value)
    })

    return `$${total.toFixed(2)} ($NZD)`
  }

  setProductTotal() {
    const total = this.getProductTotal()

    document.querySelectorAll(".product-total").forEach(el => {
      let totalElement = el.querySelector(".total")
      if (!totalElement) {
        totalElement = document.createElement("div")
        totalElement.classList.add("total")
        el.prepend(totalElement)
      }
      totalElement.innerHTML = total
    })
  }

  parseProductAmount(value) {
    const delimiter = " - "

    const amount =
      value && value.includes(delimiter)
        ? value.slice(value.lastIndexOf(delimiter) + delimiter.length)?.replace(/[^\d.]/g, "")
        : ""

    return amount ? parseFloat(amount) : 0
  }
}

export default Formfields
